export const LIST = "LUCKY_SPIN_PRIZE_LIST";
export const DROPDOWN = "LUCKY_SPIN_PRIZE_DROPDOWN";
export const DETAILS = "LUCKY_SPIN_PRIZE_DETAILS";
export const STORE = "LUCKY_SPIN_PRIZE_STORE";
export const UPDATE = "LUCKY_SPIN_PRIZE_UPDATE";
export const UPDATE_STATUS = "LUCKY_SPIN_PRIZE_UPDATE_STATUS";